<template>
  <div class="publications-by-source">

    <ul class="publications-by-source__header">
      <li class="publications-by-source__title">
        {{chartTitle}}
      </li>
      <li class="publications-by-source__tools" v-if="!dataEmpty">
        <el-button type="text" class="publications-by-source__tools-button" :disabled="saveChart" @click="onSave">
          <i class="material-icons color_grey">save</i>
        </el-button>
        <el-button type="text" class="publications-by-source__tools-button" v-if="!isEdit" @click="editChart">
          <i class="material-icons color_grey">edit</i>
        </el-button>
      </li>
    </ul>

    <el-card shadow="hover" class="publications-by-source__card" v-loading="pending">
      <publications-by-source-header :chart-name="name"/>
      <template v-if="!dataEmpty">
        <publications-by-source-body
          :data="data"
          :chart-name="name"
          :save-chart="saveChart"
          :title="chartTitle"
          @onSavedChart="handleSaved"
          @onSaveChart="handleSave"
        />
      </template>

      <template v-else>
        {{$t('feed.analytics.publications.noData')}}.
      </template>

    </el-card>
  </div>
</template>

<script>
  /*
    Компонент Источников
    родительский Common
  */

// config
import sourceShortcuts from "../../../../../../../config/sourceShortcuts";

// mixins
import { analytics } from "../../../../../../../mixins/analytics";

import {
  TRUST_HOURLY
} from "../../../../../../../store/actions/analytics";

// components
import PublicationsBySourceHeader from "./header/PublicationsBySourceHeader";
import PublicationsBySourceBody from "./body/PublicationsBySourceBody";

// vuex
import { mapGetters } from "vuex";

export default {
  name: "PublicationsBySource",
  data() {
    return {
      name: "PublicationsBySource",
      saveChart: false
    };
  },
  computed: {
    ...mapGetters([
      "socialList",
    ]),
    sourceOf() {
      let sourceOf = [];
      let sourceShortcuts = this.$t('feed.analytics.publications.body.shortcuts');
      if (Object.keys(this.data).length) {
        Object.entries(sourceShortcuts).forEach(shortcut => {
          if (this.socialList.includes(shortcut[0])) {
            if(this.data[shortcut[0]]) {
              sourceOf.push(shortcut[1]);
            }
          }
        });
      }

      return  sourceOf;
    },
    chartTitle() {
      return `${this.$t('feed.analytics.publications.title')}: ${this.sourceOf.join(", ")}`;
    },
  },
  beforeMount() {
    this.$store.dispatch(TRUST_HOURLY, {chart: this.name, thread: this.$route.params.threadId});
  },
  mixins: [
    analytics
  ],
  components: {
    PublicationsBySourceHeader,
    PublicationsBySourceBody
  }
};
</script>

<style>
.publications-by-source {
  margin-bottom: 40px;
}

.publications-by-source__header {
  display: flex;
  justify-content: space-between;
  align-items: start;
  padding: 0;
  margin: 0;
  list-style: none;
}

.publications-by-source__title {
  margin-bottom: 20px;
  font-family: "Roboto", "Arial", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;

  color: #5E6D82;
}

.publications-by-source__tools .material-icons {
  font-size: 16px;
}

.publications-by-source__tools {
  margin-top: 4px;
  margin-right: 15px;
}

.publications-by-source__tools-button {
  padding: 0;
  color: #5e6d82;
}

.publications-by-source__tools-button:hover {
  color: #B3BCCC;
  font-size: 12px;
}

@media screen and (max-width: 480px) {
  .publications-by-source__card {
    overflow-x: auto;  }
  .publications-by-source__tools {
    display: none;
  }
}
</style>
